export interface MmoSyncJob<T=unknown> {
  id:string;status:'running'|'completed'|'failed'|'cancelled';phase:'scanning'|'archiving'|'provisioning'|'indexing';
  completedProducts?:number;totalProducts?:number;currentProductName?:string;error?:string;result?:T;
}
export async function waitForMmoSync<T>(initial:MmoSyncJob<T>,options:{
  read:(id:string)=>Promise<MmoSyncJob<T>>;
  onProgress?:(job:MmoSyncJob<T>)=>void;
  signal?:AbortSignal;wait?:(milliseconds:number)=>Promise<void>;
}):Promise<T>{
  let job=initial,failures=0;
  const check=()=>{if(options.signal?.aborted)throw new DOMException('Stopped monitoring','AbortError');};
  const wait=options.wait??(ms=>new Promise<void>((resolve,reject)=>{
    const finish=()=>{options.signal?.removeEventListener('abort',abort);resolve();};
    const timer=setTimeout(finish,ms);
    const abort=()=>{clearTimeout(timer);options.signal?.removeEventListener('abort',abort);reject(new DOMException('Stopped monitoring','AbortError'));};
    options.signal?.addEventListener('abort',abort,{once:true});
  }));
  for(;;){
    check();options.onProgress?.(job);
    if(job.status==='failed' || job.status==='cancelled')throw new Error(job.error||(job.status==='cancelled'?'Đã dừng theo yêu cầu của bạn.':'Đồng bộ sản phẩm thất bại.'));
    if(job.status==='completed'){
      if(job.result===undefined)throw new Error('Chưa đọc được kết quả đồng bộ.');
      return job.result;
    }
    await wait(2000);check();
    try{job=await options.read(job.id);failures=0;}
    catch(error){
      check();
      const status=(error as {response?:{status?:number}})?.response?.status;
      if(status===401 || status===403 || status===404)throw error;
      if(++failures>=5)throw new Error('Mất kết nối theo dõi. Tác vụ vẫn chạy trên máy chủ; mở lại mục Đồng bộ để xem tiếp.');
    }
  }
}
export function describeMmoSync(job:MmoSyncJob):string{
  if(job.status==='cancelled')return job.error||'Đã dừng theo yêu cầu của bạn.';
  if(job.phase==='scanning')return 'Đang quét sản phẩm từ Ông Chú MMO…';
  if(job.phase==='archiving')return 'Đang lưu trữ sản phẩm cũ và chuẩn bị thư mục hôm nay…';
  if(job.phase==='indexing')return 'Đang tổng hợp ảnh và danh sách sản phẩm…';
  return `Đã xử lý ${job.completedProducts??0}/${job.totalProducts??0} sản phẩm · Đang tải và kiểm tra ảnh${job.currentProductName?`: ${job.currentProductName}`:'…'}`;
}
